import { render } from "./Home.vue?vue&type=template&id=dc31bfca&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=dc31bfca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\17630037586\\Desktop\\新建文件夹 (2)\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc31bfca"]])

export default __exports__